import { Contact } from './contact.model';
import { DriveFolder } from './drive.folder';
import { OdooModel } from './odoo-model.model';
import { OdooMultiRelationship } from './odoo-multi-relationship.model';
import { OdooRelationship } from './odoo-relationship.model';
import { SaleOrder } from './sale-order.model';
import { Stage } from './stage.model';
import { IConnectable, TrelloCardEntry2 } from './trello-card';
import { User } from './user.model';

/**
 * crm.lead
 */
// export class Lead extends OdooModel implements IConnectable<Lead> {
export class Lead extends OdooModel {
   
    public readonly ODOO_MODEL = 'crm.lead';
    name:string = ""
    title:string = ""
    area: string = ""
    partner_id:OdooRelationship<Contact> = new OdooRelationship<Contact>()
    description:string = ""
    stage_id:OdooRelationship<Stage> = new OdooRelationship<Stage>()
    drive_link_docs:string 
    drive_link_production:string 
    drive_link_project:string 
    drive_link_pos: any
    tracking_code:string = ""
    city:string = ""
    street:string = ""
    user_id :OdooRelationship<User> = new OdooRelationship<User>()
    // lng: any
    // lat: any
    cordinates: string = "" // lat,lng
    // order_ids: OdooMultiRelationship<SaleOrder> = new OdooMultiRelationship(SaleOrder)
    trello_ids: OdooMultiRelationship<TrelloCardEntry2> = new OdooMultiRelationship(TrelloCardEntry2)
    drive_ids: OdooMultiRelationship<DriveFolder> = new OdooMultiRelationship(DriveFolder)

    calendar_event_count: Number = 0

    
    // write_date:string = "" 

    getTitle() {
        return this.partner_id.name  + " - " + this.city + " - " + this.name + " - " + this.id  
    }

    create() {
        return new Lead()
    }


   
}